import React, { Component } from 'react';
import Dropdown from 'views/Dropdown.v2';
import {
  hideDropdown,
} from 'config/utils';

const Cart = () => <span></span>;
const CartButton = Cart;

export default class CartDropdown extends Component {
  constructor() {
    super();
    this.state = {
      Cart,
      CartButton,
    };
  }

  componentDidMount () {
    require.ensure([], (require) => {
      const Cart = require('Cart').default;
      const CartButton = require('CartButton').default;

      this.setState({
        Cart,
        CartButton,
      });
    }, 'cart');
  }

  render () {
    const { CartButton, Cart } = this.state;

    return (
      <Dropdown
        trigger={<CartButton />}
        style={{ width: 300 }}
        className="dropdown-follow cart--dropdown"
        >
        <Cart />
        <button
          style={{ borderRadius: 0 }}
          className="btn btn-block btn-green"
          onClick={() => {
            hideDropdown();
            this.props.onClick();
          }}
          >View Cart
        </button>
      </Dropdown>
    );
  }
}



// WEBPACK FOOTER //
// ./src/common/views/CartDropdown.js